import { SITE_NAME, SITE_URL } from '../constants/seoConfig';

export function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/images/flea-logo.png`,
    description:
      'Flea Marketplace is a trusted buy-and-sell platform for new and used items in Egypt, with delivery, Aura reputation, and wedding & luxury verticals.',
    areaServed: {
      '@type': 'Country',
      name: 'Egypt',
    },
    sameAs: [
      'https://www.instagram.com/flea.eg/',
      'https://www.tiktok.com/@flea.eg',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'support@flea-marketplace.com',
      telephone: '+201040895962',
      availableLanguage: ['English', 'Arabic'],
      areaServed: 'EG',
    },
    knowsAbout: [
      'Second-hand shopping in Egypt',
      'Pre-owned items',
      'Thrift shopping',
      'Sustainable resale',
    ],
  };
}

export function buildWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/pre-owned-items?search={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function buildProductSchema(item, canonicalPath) {
  if (!item) return null;
  const image =
    item.primary_image || item.image_url || (item.images?.[0]?.image ?? null);
  const imageUrl = image
    ? image.startsWith('http')
      ? image
      : `${SITE_URL}${image.startsWith('/') ? '' : '/'}${image}`
    : `${SITE_URL}/images/flea-logo.png`;

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: item.title,
    description: item.description || `${item.title} — ${item.category} on Flea Marketplace Egypt`,
    image: imageUrl,
    category: item.category,
    offers: {
      '@type': 'Offer',
      priceCurrency: 'EGP',
      price: item.price ?? 0,
      availability: item.in_stock > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
      url: `${SITE_URL}${canonicalPath || ''}`,
    },
    brand: {
      '@type': 'Brand',
      name: SITE_NAME,
    },
  };
}

export function buildBreadcrumbSchema(crumbs) {
  if (!crumbs?.length) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: c.url ? `${SITE_URL}${c.url}` : undefined,
    })),
  };
}

export function buildFaqSchema(faqItems) {
  if (!faqItems?.length) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };
}

export function buildItemListSchema(items, listName = 'Marketplace listings') {
  if (!items?.length) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: listName,
    numberOfItems: items.length,
    itemListElement: items.slice(0, 12).map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `${SITE_URL}/pre-owned-items/${String(item.category || 'items').toLowerCase().replace(/\s+/g, '-')}/${String(item.title || 'item').toLowerCase().replace(/\s+/g, '-')}`,
      name: item.title,
    })),
  };
}
